import React from 'react'
import AppStoreButtons from '../../../app-store-buttons'
import { YoutubeMonitor } from '../../../youtube-monitor'

export const AboutSection = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="row content">
          <div className="col-lg-6">
            <h2>The Next Generation of Milk Hauling</h2>
            <h3>
              Total Milk Hauler Next pairs a real-time web back-office with a redesigned driver mobile app — one
              platform that takes a milk pickup from the tanker in the field all the way to your payroll system.
            </h3>
            <p>
              Drivers capture tickets offline and sync with one tap; the office watches hauled weights, tickets, routes,
              and driver licenses update live.
            </p>
            <div>
              <AppStoreButtons
                googleLink="https://play.google.com/store/apps/details?id=com.totalmilk.haulerv16"
                iosLink="https://apps.apple.com/ph/app/total-milk-hauler-next/id6783843093"
              />
            </div>
            <div className="mt-3">
              <a href="https://web.hauler.totalmilk.com/" target="_blank" rel="noreferrer" className="btn btn-primary">
                Visit Web App
              </a>
            </div>
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <YoutubeMonitor youtubeId="qehQG4a_FBk" />
          </div>
        </div>
      </div>
    </section>
  )
}
